const a = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCAgZD0iTTEzIDExaDl2MmgtOXY5aC0ydi05SDJ2LTJoOVYyaDJ6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  a as default
};
//# sourceMappingURL=plus-41fe34c7.mjs.map
